module.exports = __webpack_public_path__ + "img/wx_kx_bc@2x.0734ac0a.png";